import { useEffect } from "react";

const DEFAULT_SITE_NAME = "skilll.dev";
const DEFAULT_OG_TYPE = "website";

function upsertMeta(selector, createTag) {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = createTag();
    document.head.appendChild(tag);
  }
  return tag;
}

export default function useSEO({
  title,
  description,
  keywords,
  canonical,
  ogImage,
  ogType = DEFAULT_OG_TYPE,
  robots,
}) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }

    const setMeta = (name, content, attr = "name") => {
      if (!content) return;
      const selector = `meta[${attr}="${name}"]`;
      const tag = upsertMeta(selector, () => {
        const meta = document.createElement("meta");
        meta.setAttribute(attr, name);
        return meta;
      });
      tag.setAttribute("content", content);
    };

    setMeta("description", description);
    setMeta("keywords", keywords);
    setMeta("robots", robots);

    setMeta("og:title", title, "property");
    setMeta("og:description", description, "property");
    setMeta("og:type", ogType, "property");
    setMeta("og:site_name", DEFAULT_SITE_NAME, "property");
    if (canonical) setMeta("og:url", canonical, "property");
    if (ogImage) setMeta("og:image", ogImage, "property");

    setMeta("twitter:card", "summary_large_image");
    setMeta("twitter:title", title);
    setMeta("twitter:description", description);
    if (ogImage) setMeta("twitter:image", ogImage);

    if (canonical) {
      const link = upsertMeta("link[rel='canonical']", () => {
        const canonicalLink = document.createElement("link");
        canonicalLink.setAttribute("rel", "canonical");
        return canonicalLink;
      });
      link.setAttribute("href", canonical);
    }
  }, [title, description, keywords, canonical, ogImage, ogType, robots]);
}
